/* Pampas Mood — כמות, עיצוב וקובץ הדפסה פר יחידה
   Ran 21.10: "כמה עיצובים שונים" on the sticker add-on uses the candle's designs block and manager (window.PMDesigns.create,
   assets/pampas-designs.js). The designs fill the hidden per-unit fields, so the add-on line, its ₪ charge (one per design)
   and the per-unit list stay as before; one print file per design goes on the product line at add to cart. */
(() => {
  if (window.pmAddonQtyReady) return;
  window.pmAddonQtyReady = true;

  const DEBUG = /pmqty_debug/.test(location.search);
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const SPACES = new RegExp('[ \t\r\n]+', 'g');

  const injectCSS = () => {
    if (document.getElementById('pmAddonQtyStyles')) return;
    const st = document.createElement('style');
    st.id = 'pmAddonQtyStyles';
    st.textContent = [
      '.pampas-addons [hidden]{display:none!important}',
      '.pampas-addon__stepper>span{order:1}',
      '.pampas-addon__stepper [data-qty-plus]{order:2}',
      '.pampas-addon__stepper [data-qty-out]{order:3}',
      '.pampas-addon__stepper [data-qty-minus]{order:4}',
      '.pampas-addon-row.is-dz .pm-addon-ready{display:none!important}'
    ].join('');
    document.head.appendChild(st);
  };
  injectCSS();

  const qtyInputFor = (row) => {
    let el = row;
    while (el && el !== document.documentElement) {
      const found = el.querySelector && el.querySelector('input[name="quantity"],select[name="quantity"]');
      if (found) return found;
      el = el.parentElement;
    }
    return q('input[name="quantity"],select[name="quantity"]');
  };

  const formFor = (row) => {
    let el = row;
    while (el && el !== document.documentElement) {
      const found = el.querySelector && el.querySelector('form[action*="/cart/add"]');
      if (found) return found;
      el = el.parentElement;
    }
    return q('form[action*="/cart/add"]');
  };

  const productQty = (row) => {
    const el = qtyInputFor(row);
    const v = parseInt((el && el.value) || '1', 10);
    const n = Math.max(1, isNaN(v) ? 1 : v);
    if (DEBUG) console.log('[pmqty] product qty =', n, 'from', el);
    return n;
  };

  const norm = (v) => String(v || '').normalize('NFC').replace(SPACES, ' ').trim();
  /* PL-02: the one ₪ format (window.PMMoney, layout/theme.liquid) */
  const money = (cents) => {
    if (window.PMMoney) return window.PMMoney(cents);
    const c = Math.round(cents), a = c % 100;
    return '₪' + Math.floor(c / 100) + (a ? '.' + String(100 + a).slice(1) : '');
  };

  const rowQty = (row) => Math.max(1, parseInt(row.dataset.qty || '1', 10) || 1);
  const rowMode = (row) => (q('[data-design-mode]:checked', row) || {}).value || 'same';
  const isText = (row) => row.dataset.textMode === '1';
  const isDesignable = (row) => {
    const cb = q('input[data-addon-variant]', row);
    return isText(row) && !!(cb && cb.dataset.personalizationMode === 'sticker');
  };
  const priceCents = (row) => parseInt(row.dataset.priceCents || '0', 10) || 0;
  const isChecked = (row) => {
    const cb = q('input[data-addon-variant]', row);
    return !!(cb && cb.checked);
  };

  const rowTexts = (row) => {
    if (!isText(row)) return [];
    if (!isDesignable(row)) {
      const t = q('[data-addon-text-main]', row);
      return [String((t && t.value) || '').trim()];
    }
    if (rowQty(row) < 2 || rowMode(row) === 'same') {
      const t = q('[data-addon-text-main]', row);
      return [String((t && t.value) || '').trim()];
    }
    return qa('[data-unit-text]', row).slice(0, rowQty(row)).map((el) => String(el.value || '').trim());
  };

  /* REQ-027 (Ran 23.10, R-34): every sticker is charged, one design or several: 10 stickers = 10 × the sticker price.
     Several designs add the price once more per extra design: design 1 is included (Ran 23.10: "תוספת נוספת של 4 ש״ח לכל עיצוב
     (בנוסף ל4 של המדבקה)"; "העיצוב הראשון (כלול) במחיר"), as its own line (the design charge, _pm_distinct_design_charge);
     one design for all adds nothing. */
  const chargeUnits = (row) => rowQty(row);
  const designGroups = (row) => {
    const qty = rowQty(row);
    if (!isText(row) || !isDesignable(row)) return 1;
    if (qty < 2 || rowMode(row) === 'same') return 1;
    const units = qa('[data-unit-text]', row).slice(0, qty);
    if (units.some((t) => t._pmDesignGroup)) return Math.max(1, new Set(units.map((t) => t._pmDesignGroup)).size);
    const seen = new Set();
    rowTexts(row).forEach((t) => { const c = norm(t); if (c) seen.add(c); });
    return Math.max(1, seen.size);
  };

  const missingTexts = (row) => {
    if (isText(row) && !isDesignable(row)) {
      return norm(rowTexts(row)[0]) ? [] : [1];
    }
    if (!isText(row) || rowQty(row) < 2 || rowMode(row) === 'same') return [];
    return rowTexts(row).map((t, i) => (norm(t) ? 0 : i + 1)).filter(Boolean);
  };

  /* ---------- several designs: the designs block and manager (Ran 21.10) ---------- */

  const textOfRm = (rm) => {
    if (!rm) return '';
    if (window.PMSticker && window.PMSticker.textOf) return String(window.PMSticker.textOf(rm) || '').trim();
    return [rm.heading, rm.body, rm.from].map((x) => String(x || '').trim()).filter(Boolean).join('\n');
  };
  const hasArt = (rm) => !!(rm && (rm.logo || (rm.extras || []).length || (rm.heart && rm.heart.on)));
  const isDz = (row) => isChecked(row) && isDesignable(row) && rowQty(row) >= 2 && rowMode(row) === 'different';

  /* the hidden per-unit fields the add path reads: each sticker gets its design's text, group and model */
  const writeUnits = (row, list, on) => {
    const box = q('[data-unit-texts]', row);
    if (!box) return;
    box.hidden = true;
    const qty = rowQty(row);
    let tas = qa('[data-unit-text]', box);
    if (tas.length !== qty) {
      box.replaceChildren();
      for (let i = 0; i < qty; i++) {
        const ta = document.createElement('textarea');
        ta.dataset.unitText = '1';
        ta.hidden = true;
        ta.tabIndex = -1;
        box.append(ta);
      }
      tas = qa('[data-unit-text]', box);
    }
    row._unitDone = {};
    tas.forEach((ta) => { ta.value = ''; delete ta._pmDesignGroup; ta._pmEdModel = null; });
    if (!on) return;
    let u = 0;
    list.forEach((d, i) => {
      const t = d.ready ? (textOfRm(d.rm) || ('עיצוב ' + (i + 1) + (hasArt(d.rm) ? ' (לוגו)' : ''))) : '';
      for (let k = 0; k < d.n && u < tas.length; k++, u++) {
        tas[u].value = t;
        tas[u]._pmDesignGroup = d.id;
        tas[u]._pmEdModel = d.rm || null;
        if (d.ready) row._unitDone[u] = true;
      }
    });
  };

  const dzOf = (row) => {
    if (row._pmDz) return row._pmDz;
    if (!isDesignable(row) || !window.PMDesigns || !window.PMDesigns.create) return null;
    const mount = q('[data-design-modes]', row);
    if (!mount) return null;
    const holder = document.createElement('textarea');
    row._pmDz = window.PMDesigns.create({
      mount: mount,
      qty: () => rowQty(row),
      fee: priceCents(row) / 100,
      /* design 1 is included, every other design +the price (Ran 23.10) */
      one: 'מדבקה', many: 'מדבקות', fem: true,
      /* design 1 starts as the add-on's single design, when it was made */
      first: () => {
        const t = q('[data-addon-text-main]', row);
        const cp = (o) => (o ? JSON.parse(JSON.stringify(o)) : null);
        return t && t._pmEdModel ? { rm: cp(t._pmEdModel), M: cp(t._pmEdEditor), ready: true } : null;
      },
      sync: (list, on) => { writeUnits(row, list, on); markCharge(row); },
      /* the add-on's round 5 cm sticker in the editor (flat, no candle); the holder is not in the row, so closing never unticks the add-on */
      editor: (o) => { o.addon = holder; },
      onMode: () => {
        const r = q('[data-design-mode][value="same"]', row);
        if (r) r.checked = true;
        refresh(row);
      }
    });
    return row._pmDz;
  };

  const refresh = (row) => {
    const max = productQty(row);
    const checked = isChecked(row);

    if (rowQty(row) > max) row.dataset.qty = String(max);
    const qty = rowQty(row);

    const stepper = q('[data-addon-stepper]', row);
    if (stepper) stepper.hidden = !checked || max < 2;

    const out = q('[data-qty-out]', row);
    if (out) out.textContent = String(qty);

    const minus = q('[data-qty-minus]', row);
    const plus = q('[data-qty-plus]', row);
    if (minus) minus.disabled = qty <= 1;
    if (plus) plus.disabled = qty >= max;

    const modes = q('[data-design-modes]', row);
    if (modes) modes.hidden = !checked || !isDesignable(row) || qty < 2;
    qa('[data-design-mode]', row).forEach((r) => { const l = r.closest('.pm-dz__opt'); if (l) l.classList.toggle('is-on', r.checked); });
    qa('[data-cc-q]', row).forEach((n) => { n.textContent = String(qty); });

    const main = q('[data-addon-text-main]', row);
    if (main) main.hidden = !checked || !isText(row) || (isDesignable(row) && qty >= 2 && rowMode(row) === 'different');

    row.classList.toggle('is-dz', isDz(row));
    const units = q('[data-unit-texts]', row);
    if (units) units.hidden = true;
    const dz = isDesignable(row) ? dzOf(row) : null;
    if (dz) { dz.qty(); dz.paint(); }

    markCharge(row);
    const note = q('[data-addon-note]', row);
    if (!note) return;
    note.style.removeProperty('color');

    if (!checked) { note.textContent = ''; return; }

    if (!isText(row)) {
      note.textContent = qty > 1 ? qty + ' × ' + money(priceCents(row)) + ' = ' + money(qty * priceCents(row)) : '';
      return;
    }

    if (!isDesignable(row)) {
      note.textContent = qty > 1 ? qty + ' ברכות × ' + money(priceCents(row)) + ' = ' + money(qty * priceCents(row)) : '';
      return;
    }

    if (qty < 2) { note.textContent = ''; return; }

    /* several designs: the designs block under the cards says it all */
    note.textContent = '';
  };
  /* the add-on's charged units on the row (data-charge), read by the add button's total (snippets/pampas-sticky-atc.liquid) */
  /* the per-design charge: several designs only (same variant and price as the sticker, so the add button's total adds them up) */
  const designFee = (row) => (isText(row) && isDesignable(row) && rowQty(row) >= 2 && rowMode(row) === 'different') ? Math.max(0, designGroups(row) - 1) : 0;
  const markCharge = (row) => { const c = String(chargeUnits(row) + designFee(row)); if (row.dataset.charge !== c) row.dataset.charge = c; };

  const refreshAll = (scope) => qa('[data-addon-row]', scope || document).forEach(refresh);

  const initWrap = (wrap) => {
    if (!wrap || wrap.dataset.pmQtyInit) return;
    wrap.dataset.pmQtyInit = '1';

    wrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const row = btn.closest('[data-addon-row]');
      const max = productQty(row);
      const next = rowQty(row) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
      row.dataset.qty = String(Math.min(max, Math.max(1, next)));
      refresh(row);
    });

    wrap.addEventListener('change', (e) => {
      const row = e.target.closest('[data-addon-row]');
      if (!row) return;
      if (e.target.matches('input[data-addon-variant]') && !e.target.checked) {
        row.dataset.qty = '1';
        row._unitDone = {};
        const same = q('[data-design-mode][value="same"]', row);
        if (same) same.checked = true;
        if (row._pmDz) row._pmDz.reset();
      }
      if (e.target.matches('[data-design-mode]')) {
        const dz = dzOf(row);
        if (dz) dz.choose(e.target.value === 'different' && e.target.checked ? 'many' : 'one');
      }
      refresh(row);
    });

    wrap.addEventListener('input', (e) => {
      const row = e.target.closest('[data-addon-row]');
      if (row && e.target.matches('[data-addon-text-main]')) refresh(row);
    });

    /* a radio restored by the browser does not bring the designs back: start from one design */
    qa('[data-design-mode][value="same"]', wrap).forEach((r) => { r.checked = true; });

    const anyRow = q('[data-addon-row]', wrap);
    const qtyEl = anyRow && qtyInputFor(anyRow);
    if (qtyEl && !qtyEl.dataset.pmQtyWatched) {
      qtyEl.dataset.pmQtyWatched = '1';
      ['input', 'change', 'keyup'].forEach((evt) => qtyEl.addEventListener(evt, () => refreshAll(wrap)));
      let last = qtyEl.value;
      new MutationObserver(() => {
        if (qtyEl.value !== last) { last = qtyEl.value; refreshAll(wrap); }
      }).observe(qtyEl, { attributes: true, attributeFilter: ['value'] });
      if (qtyEl.parentElement) {
        qtyEl.parentElement.addEventListener('click', () => setTimeout(() => refreshAll(wrap), 60));
      }
    }

    refreshAll(wrap);
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[data-qty-minus],[data-qty-plus]')) return;
    setTimeout(() => refreshAll(document), 80);
  });

  qa('.pampas-addons').forEach(initWrap);

  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => {
    if (n.nodeType !== 1) return;
    if (n.matches && n.matches('.pampas-addons')) initWrap(n);
    qa('.pampas-addons', n).forEach(initWrap);
  }))).observe(document.documentElement, { childList: true, subtree: true });

  /* add to cart with a design not made yet: the manager opens, as on the candle */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('form[action*="/cart/add"] [data-add-to-cart], form[action*="/cart/add"] [type="submit"]');
    if (!btn) return;
    /* PDP-02 / R6: only the rows of the form being submitted (a quick-shop modal and the product page can share a page) */
    const bform = btn.form || btn.closest('form');
    const row = qa('[data-addon-row]').find((r) => formFor(r) === bform && isChecked(r) && r._pmDz && r._pmDz.active() && r._pmDz.notReady());
    if (!row) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    row._pmDz.gate();
  }, true);

  /* one print file per design on the product line, made from the design's model before the add runs
     (pampas-personalization-print.js waits for form._pmPrintPromise). They replace the add-on's single-design print. */
  const stickers = (n) => (n === 1 ? 'מדבקה אחת' : n + ' מדבקות');
  const tplLabel = (k) => {
    if (!k) return 'טקסט חופשי';
    /* the design's name as the product page shows it (REQ-019: PMDedication's chips; it was the old designer's button text) */
    const c = window.PMDedication && window.PMDedication.chips().find((x) => x.k === k);
    if (c && c.label) return c.label;
    const T = window.pmTemplates || {};
    return (T[k] && T[k].label) || (k === 'free' ? 'טקסט חופשי' : k);
  };
  const addFile = (form, file, name) => {
    const dt = new DataTransfer();
    dt.items.add(file);
    const i = document.createElement('input');
    i.type = 'file'; i.name = name; i.hidden = true; i.dataset.pmAddonPrint = '1';
    i.files = dt.files;
    form.enctype = 'multipart/form-data';
    form.append(i);
  };
  const addHidden = (form, name, value, ded) => {
    const i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value; i.dataset.pmAddonPrint = '1';
    if (ded) i.dataset.ded = '1';
    form.append(i);
  };
  document.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!f || f.dataset.pmNative === '1' || f.dataset.pmProcessing === '1') return;
    qa('[data-pm-addon-print]', f).forEach((x) => x.remove());
    /* REQ-027 (Ran 23.10): one design on the sticker add-on: every text on it (heading, greeting, extra texts, from), in the order
       of textOf in assets/pampas-sticker.js, for the cart's dedication line (snippets/cart-item.liquid reads _טקסטים); the
       print and "טקסט הקדשה" are unchanged */
    qa('[data-addon-row]').forEach((r) => {
      if (!isChecked(r) || !isDesignable(r) || formFor(r) !== f || (r._pmDz && r._pmDz.active())) return;
      const t = q('[data-addon-text-main]', r), m = t && t._pmEdModel; if (!m) return;
      const parts = [m.heading, m.bodyOff ? '' : m.body].concat((m.extras || []).filter((x) => x && x.type === 'text').map((x) => x.text)).concat([m.from])
        .map((x) => String(x || '').replace(/\s+/g, ' ').trim()).filter(Boolean);
      if (parts.length > 1) addHidden(f, 'properties[_טקסטים]', parts.join(' | '), true);
      /* REQ-027 (Ran 23.10, "תוסיף את זה עכשיו"): the whole design on the line, as the product-page dedication path keeps it, so the
         cart's "עריכת ההקדשה" (assets/pampas-cart-edit.js) opens it; image data is left out (same rule as pampas-personalization-print.js) */
      if (!q('input[name="properties[_עיצוב]"]', f)) {
        try { addHidden(f, 'properties[_עיצוב]', JSON.stringify(m, (k, v) => ((k === 'logo' || k === 'src') && typeof v === 'string' && v.length > 200 ? '[תמונה מצורפת]' : v)), true); } catch (err) {}
      }
    });
    const row = qa('[data-addon-row]').find((r) => isChecked(r) && r._pmDz && r._pmDz.active() && formFor(r) === f);
    if (!row) return;
    /* a submit that did not come through the add button's click (Enter in a field): the same gate */
    if (row._pmDz.notReady()) { e.preventDefault(); e.stopImmediatePropagation(); row._pmDz.gate(); return; }
    if (!window.PMPrint || !window.PMPrint.file || typeof DataTransfer !== 'function') return;
    const list = row._pmDz.list();
    const prev = f._pmPrintPromise;
    f._pmPrintPromise = Promise.resolve(prev && prev.catch(() => null))
      .then(() => Promise.all(list.map((d, i) => window.PMPrint.file(d.rm, 'מדבקת-הקדשה-עיצוב-' + (i + 1) + '-עגולה-5cm.pdf').catch((err) => { console.error(err); return null; }))))
      .then((files) => {
        qa('[data-pm-print]', f).forEach((x) => x.remove());
        qa('[data-ded]', f).forEach((x) => x.remove());
        qa('[data-pm-addon-print]', f).forEach((x) => x.remove());
        /* per design, what the old per-unit flow gave the studio for each file: the count, format and size, template, font, heart */
        files.forEach((file, i) => {
          const d = list[i], rm = d.rm || {}, tag = ' — עיצוב ' + (i + 1);
          /* the candle's file name (קובץ PDF לעיצוב N), which the cart also reads as a designed line, plus the sticker count */
          const label = (i + 1) + ' · ' + stickers(d.n);
          if (file) addFile(f, file, 'properties[קובץ PDF לעיצוב ' + label + ']');
          else addHidden(f, 'properties[קובץ הדפסה לעיצוב ' + label + ']', 'יוכן בסטודיו לפי הנוסח והתבנית');
          addHidden(f, 'properties[פורמט הדפסה' + tag + ']', 'A6, 300 DPI, PDF');
          addHidden(f, 'properties[מידות קובץ' + tag + ']', '1240×1748 פיקסלים');
          addHidden(f, 'properties[תבנית' + tag + ']', tplLabel(rm.tpl));
          const font = rm.font && typeof rm.font === 'object' ? rm.font.text : rm.font;
          if (font) addHidden(f, 'properties[פונט' + tag + ']', String(font));
          addHidden(f, 'properties[לב מצויר' + tag + ']', rm.heart && rm.heart.on ? 'כן' : 'לא');
        });
        /* the add path looks for a print on the form before it approves the page's design on its own */
        const dummy = document.createElement('input');
        dummy.type = 'file'; dummy.hidden = true; dummy.dataset.pmPrint = '1'; dummy.dataset.pmAddonPrint = '1';
        f.append(dummy);
        /* the cart's quote on the product line: every design with its count (as the candle's "עיצובים" list; that key itself
           would lock the product quantity in the cart, so the list goes in טקסט הקדשה) */
        addHidden(f, 'properties[טקסט הקדשה]', list.map((d, i) => (i + 1) + '. ' + (textOfRm(d.rm).replace(/\s+/g, ' ').trim() || (hasArt(d.rm) ? '(לוגו)' : '—')) + ' — ' + stickers(d.n)).join(' | '), true);
        addHidden(f, 'properties[סוג עיצוב]', 'מדבקת הקדשה', true);
        addHidden(f, 'properties[_מקור אישור העיצוב]', 'אושר בעורך', true);
      });
  }, true);

  window.pmAddonItems = (form, wrap, handle, parentVariant) => {
    const rows = qa('[data-addon-row]', wrap).filter(isChecked);
    if (!rows.length) return null;

    const problems = [];
    const items = rows.map((row) => {
      const qty = rowQty(row);
      const units = chargeUnits(row), groups = designGroups(row);
      const props = { _linked_to: handle, _parent_variant: parentVariant, 'כמות': String(qty) };

      const dz = row._pmDz && row._pmDz.active() ? row._pmDz : null;
      if (isText(row)) {
        const miss = missingTexts(row);
        const nr = dz ? dz.notReady() : 0;
        if (nr) {
          problems.push(row.dataset.label + ' — ' + (nr === 1 ? 'עיצוב אחד עוד לא עוצב' : nr + ' עיצובים עוד לא עוצבו'));
        } else if (miss.length) {
          problems.push(isDesignable(row)
            ? row.dataset.label + ' — חסר נוסח ליחידות ' + miss.join(', ')
            : row.dataset.label + ' — חסר מלל לברכה');
        }
        props['סוג עיצוב'] = row.dataset.designLabel || '';
        if (qty >= 2 && rowMode(row) === 'different') {
          const notDesigned = [];
          for (let i = 0; i < qty; i++) {
            if (!(row._unitDone && row._unitDone[i])) notDesigned.push(i + 1);
          }
          if (notDesigned.length && !nr) problems.push(row.dataset.label + ' — יש לאשר עיצוב ליחידות ' + notDesigned.join(', '));
          props['אופן חלוקה'] = 'נוסח נפרד לכל יחידה';
          props['נוסחים'] = rowTexts(row).map((t, i) => (i + 1) + '. ' + norm(t)).join(' | ');
          props['קבצי הדפסה'] = (dz ? groups : qty) + ' קבצי PDF נפרדים מצורפים להזמנה';
          if (groups < qty) props['הערה'] = groups + ' עיצובים שונים מתוך ' + qty + ' יחידות';
        } else {
          const t = rowTexts(row)[0] || '';
          if (t) props['טקסט'] = t;
          if (qty >= 2) props['אופן חלוקה'] = 'אותו נוסח לכל ' + qty + ' היחידות';
        }
      }

      const out = [{ id: parseInt(row.dataset.variant, 10), quantity: units, properties: props }];
      const fee = designFee(row);
      if (fee) out.push({ id: parseInt(row.dataset.variant, 10), quantity: fee, properties: { _linked_to: handle, _parent_variant: parentVariant,
        _pm_distinct_design_charge: '1', 'מספר עיצובים נוספים': String(fee), 'נוסחים לפי מוצר': props['נוסחים'] || '' } });
      return out;
    }).reduce((a, x) => a.concat(x), []);

    if (problems.length) throw new Error(problems.join(' | '));
    return items;
  };
})();

